import React, { useEffect } from 'react';
import { 
    Box, 
    CircularProgress, 
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import CityLandingPage from './CityLandingPage';

interface CityData {
    displayName: string;
    seoName: string;
    description: string;
    highlights: string[];
    facts: string[];
    neighborhoods: string[];
}

const ENHANCED_CITY_DATA: Record<string, CityData> = {
    'london': {
        displayName: 'London',
        seoName: 'london',
        description: 'London\'s pub garden scene is legendary, from historic riverside terraces along the Thames to hidden courtyard gems in the City. Our sun tracking technology has mapped over 500+ beer gardens across all boroughs, revealing the capital\'s best-kept sunny secrets.',
        highlights: [],
        facts: [],
        neighborhoods: []
    },
    'bristol': {
        displayName: 'Bristol',
        seoName: 'bristol',
        description: 'Bristol\'s vibrant pub culture combines harbourside locations with hilltop gardens offering stunning views. From the historic Old City to trendy Stokes Croft, our technology reveals which beer gardens catch the most West Country sunshine.',
        highlights: [],
        facts: [],
        neighborhoods: [],
    },
    'brighton-and-hove': {
        displayName: 'Brighton and Hove',
        seoName: 'brighton-and-hove',
        description: 'Brighton\'s legendary nightlife extends to its sun-soaked beer gardens, from seafront terraces to bohemian North Laine courtyards. Our analysis shows which gardens make the most of the South Coast\'s exceptional sunshine hours.',
        highlights: [],
        facts: [],
        neighborhoods: [],
    }
};


const EnhancedCityLandingPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const getCurrentCityInfo = () => {
        const path = location.pathname;
        if (path === '/sunny-pubs-london') return { citySlug: 'london' };
        if (path === '/sunny-pubs-bristol') return { citySlug: 'bristol' };
        if (path === '/sunny-pubs-brighton-and-hove') return { citySlug: 'brighton-and-hove' };
        return { citySlug: null };
    };
    
    const { citySlug } = getCurrentCityInfo();
    const cityData = citySlug ? ENHANCED_CITY_DATA[citySlug] : null;
    
    // Always scroll to top when component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {
        if (!citySlug) {
            navigate('/');
        } else {
            window.scrollTo(0, 0);
        }
    }, [citySlug, navigate]);
    
    if (!cityData) {
        return (
            <Box sx={{ width: '100%', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress />
            </Box>
        );
    }
    
    return (
        <CityLandingPage
            cityOverride={cityData.seoName}
            isEnhancedPage={true}
            pubCount={10}
            enhancedBlurb={cityData.description}
            enhancedDisplayName={cityData.displayName}
        />
    );
};

export default EnhancedCityLandingPage;